import { makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import React from "react";
import { CandidateMyModuleViewModel } from "../../../model/me/CandidateMyModuleViewModel";
import TranslatedMessage from "../../translations/TranslatedMessage";
import MyExamsTableExamRow from "./MyExamsTableExamRow";
import MyExamsTableModuleRow from "./MyExamsTableModuleRow";

type MyExamsTableProps = {
  modules: CandidateMyModuleViewModel[];
  onCancelModule: (module: CandidateMyModuleViewModel) => void;
};

const useStyles = makeStyles(() => ({
  skipRow: {
    padding: "1px",
  },
}));

const MyExamsTable = ({ modules, onCancelModule }: MyExamsTableProps) => {
  const classes = useStyles();

  return (
    <TableContainer component={Paper} style={{ marginTop: "0.5rem", marginBottom: "1rem" }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <TranslatedMessage id="home.myExams.table.moduleColumn" />
            </TableCell>
            <TableCell>
              <TranslatedMessage id="home.myExams.table.examColumn" />
            </TableCell>
            <TableCell>
              <TranslatedMessage id="home.myExams.table.examTypeColumn" />
            </TableCell>
            <TableCell>
              <TranslatedMessage id="home.myExams.table.locationColumn" />
            </TableCell>
            <TableCell>
              <TranslatedMessage id="home.myExams.table.dateColumn" />
            </TableCell>
            <TableCell>
              <TranslatedMessage id="home.myExams.table.timeColumn" />
            </TableCell>
            <TableCell>
              <TranslatedMessage id="home.myExams.table.roomColumn" />
            </TableCell>
            <TableCell>
              <TranslatedMessage id="home.myExams.table.statusColumn" />
            </TableCell>
            <TableCell>
              <TranslatedMessage id="home.myExams.table.gradeColumn" />
            </TableCell>
            <TableCell>
              <TranslatedMessage id="home.myExams.table.actionsColumn" />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell colSpan={10} className={classes.skipRow} />
          </TableRow>
          {modules.map((module, moduleIndex) => {
            return (
              <React.Fragment key={moduleIndex}>
                <MyExamsTableModuleRow module={module} onCancel={onCancelModule} />
                {module.exams.map((exam, examIndex) => (
                  <MyExamsTableExamRow key={examIndex} exam={exam} />
                ))}
                <TableRow>
                  <TableCell colSpan={10} className={classes.skipRow} />
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MyExamsTable;
